'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.detectAdblockAndAlert = detectAdblockAndAlert;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AdblockDisableInstructionsView = require('./AdblockDisableInstructionsView');

var _AdblockDisableInstructionsView2 = _interopRequireDefault(_AdblockDisableInstructionsView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function detectAdblocker() {
    var testAd = document.createElement('div');
    testAd.innerHTML = '&nbsp;';
    testAd.className = 'adsbox';
    document.body.appendChild(testAd);
    return testAd.offsetHeight === 0;
}

function detectAdblockAndAlert(application) {
    var detectionEnabled = application.settings.get('checkOnAdblockersEnabled', false);

    if (detectionEnabled && detectAdblocker()) {
        return Promise.reject({ content: _react2.default.createElement(_AdblockDisableInstructionsView2.default, null) });
    }

    return;
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/adblock/adblockUtils.js
// module id = 1311
// module chunks = 118